import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "_pt-3 _pb-3 _px-3" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h1 _mb-3" }
const _hoisted_3 = {
  key: 0,
  class: "_flexwrap _mt-2"
}
const _hoisted_4 = { class: "_ttl" }
const _hoisted_5 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_admin_link = _resolveComponent("admin-link")
  const _component_drawer = _resolveComponent("drawer")

  return (_openBlock(), _createBlock(_component_drawer, {
    "is-open": $props.isDrawerOpen,
    onClose: $options.onCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass($options.actionsClassList)
      }, [
        ($props.hasClearButton)
          ? (_openBlock(), _createBlock(_component_admin_link, {
              key: 0,
              theme: "light",
              onClick: $options.onClear,
              "data-qa": "button:Clear"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Resources.Search.SearchProjectsFiltersSearchClearButton), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["onClick"]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "gfu-link _tc--light",
            type: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onCancel && $options.onCancel(...args)), ["prevent"])),
            "data-qa": "button:Cancel"
          }, _toDisplayString(_ctx.Resources.Profile.UserFollowSettingsCancelButton), 1 /* TEXT */),
          _createVNode(_component_base_button, {
            class: "_ml-3",
            theme: "accent",
            width: "compact",
            enabled: $options.canFilter,
            onClick: _withModifiers($options.onSearch, ["prevent"]),
            "data-qa": "button:Search"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.Search.SearchProjectsFiltersSearchApplyButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["enabled", "onClick"])
        ])
      ], 2 /* CLASS */)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleFields, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.modelName,
            class: "_mb-3"
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent($options.resolveComponent(field.type)), _mergeProps({
              modelValue: $data.model[field.modelName],
              "onUpdate:modelValue": $event => (($data.model[field.modelName]) = $event)
            }, { ref_for: true }, $options.getComponentProps(field), {
              name: `model.${field.modelName}`,
              onInput: (val) => field.onInput && field.onInput(val, $data.model),
              "data-qa": `filter:${field.qa}`
            }), null, 16 /* FULL_PROPS */, ["modelValue", "onUpdate:modelValue", "name", "onInput", "data-qa"])),
            _createCommentVNode(" generic inline tag rendering "),
            (field.renderTags && $options.getTagsForField(field).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getTagsForField(field), (tag) => {
                    return (_openBlock(), _createBlock(_component_base_button, {
                      key: tag.value,
                      class: "_mr-1 _mb-1",
                      width: "compact",
                      theme: "searchSecondary",
                      onClick: $event => ($options.onTagRemove(field, tag)),
                      "data-qa": `tag-tile:${tag.label}`
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("strong", _hoisted_4, _toDisplayString(tag.label), 1 /* TEXT */),
                        _createVNode(_component_base_icon, {
                          name: "window-close",
                          class: "_ml-1"
                        })
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "data-qa"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "onClose"]))
}